// @ts-nocheck
import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

/**
 * Notification card shown when an admin manually adjusts the user's points.
 * Reads the signed `amount` and optional `reason` out of the blueprint data
 * and renders different copy for add vs. remove.
 */
export default class PointsManualNotification extends Notification {
  icon() {
    var _data$amount;
    const data = this.attrs.notification.content() || {};
    const amount = Number((_data$amount = data == null ? void 0 : data.amount) != null ? _data$amount : 0);
    return amount >= 0 ? 'fas fa-coins' : 'fas fa-minus-circle';
  }
  href() {
    // Tapping the notification takes the user to the Rewards page so they
    // see the updated balance in context.
    try {
      return app.route('pointSystem.shop');
    } catch (_unused) {
      return '/';
    }
  }
  content() {
    var _data$amount2, _this$attrs$notificat, _this$attrs$notificat2, _fromUser$displayName;
    const data = this.attrs.notification.content() || {};
    const amount = Number((_data$amount2 = data == null ? void 0 : data.amount) != null ? _data$amount2 : 0);
    const abs = Math.abs(amount).toLocaleString();
    const fromUser = (_this$attrs$notificat = (_this$attrs$notificat2 = this.attrs.notification).fromUser) == null ? void 0 : _this$attrs$notificat.call(_this$attrs$notificat2);
    const adminName = (fromUser == null || (_fromUser$displayName = fromUser.displayName) == null ? void 0 : _fromUser$displayName.call(fromUser)) || app.translator.trans('ramon-point-system.forum.notifications.admin_fallback');
    const key = amount >= 0 ? 'ramon-point-system.forum.notifications.points_added' : 'ramon-point-system.forum.notifications.points_removed';
    return app.translator.trans(key, {
      admin: adminName,
      amount: abs
    });
  }
  excerpt() {
    const data = this.attrs.notification.content() || {};
    return data != null && data.reason && data.reason !== 'admin.adjustment' ? String(data.reason) : null;
  }
}
flarum.reg.add('ramon-point-system', 'forum/components/PointsManualNotification', PointsManualNotification);